import { ReactNode } from 'react'
import { Avatar } from '@systemeio/components'
import { useTranslation } from 'next-i18next/pages'
import { RecentCommenterInterface } from 'modules/community/types/post-info'

interface CommentAuthorPreviewProps {
  author: RecentCommenterInterface
}

export default function CommentAuthorPreview({ author }: CommentAuthorPreviewProps): ReactNode {
  const { t } = useTranslation()

  return (
    <Avatar
      src={author.avatarUrl || undefined}
      displayName={author.displayName}
      alt={t('community.post_announce.post_info.avatar.alt', { name: author.displayName })}
      size="md"
      rootProps={{
        title: t('community.post_announce.post_info.avatar.title', { name: author.displayName }),
      }}
    />
  )
}
